import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LenguagesHelper } from '@app/core/helpers/lenguages.helper';
import { user_comments } from '../user-comments';

@Component({
    selector: 'app-user-cards-carousel',
    templateUrl: './user-cards-carousel.component.html',
    styleUrls: ['./user-cards-carousel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserCardsCarouselComponent {
    public userComments: Array<any> = [];
    private lenguagesHelper: LenguagesHelper = new LenguagesHelper();

    public constructor(private router: Router) {
        this.userComments = user_comments[this.lenguagesHelper.extractLenguageFromPath(this.router.url)] ?? user_comments['es-AR'];
        this.router.events.subscribe((navigation: any) => {
            if (navigation instanceof NavigationEnd) {
                this.userComments = user_comments[this.lenguagesHelper.extractLenguageFromPath(this.router.url)] ?? user_comments['es-AR'];
            }
        });
    }
}
